import { ProviderConfig } from "../types";

export const samcartConfig: ProviderConfig = {
  allowedRoutes: [
    // Keep "dashboard" first — ProviderRoute falls back to the first entry
    // here when it blocks an unrelated route, so this doubles as the
    // provider's landing page.
    "dashboard",
    "campaigns",
    "automations",
    "audience",
    "calendar",
    "account-settings.ai-tuning",
    "account-settings.profile",
    "account-settings.sender-details",
    "account-settings.brand-kit",
    "account-settings.hero-image",
    "account-settings.dns",
    // Onboarding must stay reachable — blocking these strands new SamCart
    // accounts mid-signup (ProviderRoute bounces them to the dashboard
    // before onboarding is FINISHED).
    "onboarding.plan-selection",
    "onboarding.brand-voice",
  ],
  allowedFeatures: [
    "dashboard.revenue",
    "campaigns.createButton",
    "automations.createButton",
  ],
  allowedAutomations: ["Thank You For Purchase", "Abandoned Cart"],
};
